import { IColumn } from "@/interfaces/table";
import EditColumnsIcon from "../icons/EditColumnsIcon";
import Modal from "../Modal/Modal";
import ColumnEditor from "./ColumnEditor";

export default function ColumnEditorModal<T>(props: {
  defaultColumns: IColumn<T>[];
  columns: IColumn<T>[];
  setActiveColumns: React.Dispatch<React.SetStateAction<T[]>>;
}) {
  const { columns, setActiveColumns, defaultColumns } = props;

  return (
    <Modal
      title={
        <>
          <EditColumnsIcon width={20} />
          Redigér kolonner
        </>
      }
      description=""
      className="c-modal--column-editor"
    >
      <ColumnEditor
        columns={columns}
        setActiveColumns={setActiveColumns}
        defaultColumns={defaultColumns}
      />
    </Modal>
  );
}
